<template>
  <a-row :gutter="24">
    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="受委托进行招租活动" prop="hasEntrustRent">
            <a-radio-group v-model="form.hasEntrustRent">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租方名称" prop="lessorName">
            <a-input
              v-model="form.lessorName"
              placeholder="请输入出租方名称"
              :disabled="form.hasEntrustRent == 0"
            />
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="出租方类型" prop="lessorType">
            <a-radio-group
              v-model="form.lessorType"
              :disabled="form.hasEntrustRent == 0"
            >
              <a-radio :value="1">法人</a-radio>
              <a-radio :value="2">自然人</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租方联系人" prop="businessPrincipal">
            <a-input
              v-model="form.businessPrincipal"
              placeholder="请输入出租方联系人"
            />
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            label="出租方联系人电话"
            prop="principalContactNumber"
          >
            <a-input
              v-model="form.principalContactNumber"
              placeholder="请输入出租方联系人电话"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.lessorType == 2">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租方证件类型" prop="personCertType">
            <a-radio-group
              v-model="form.personCertType"
              :disabled="form.hasEntrustRent == 0"
            >
              <a-radio style="margin: 4px 0px" :value="0">身份证</a-radio>
              <a-radio style="margin: 4px 0px" :value="1">护照</a-radio>
              <a-radio style="margin: 4px 0px" :value="2">军官证</a-radio>
              <a-radio style="margin: 4px 0px" :value="3">士兵证</a-radio>
              <a-radio style="margin: 4px 0px" :value="4">回乡证</a-radio>
              <a-radio style="margin: 4px 0px" :value="5">户口本</a-radio>
              <a-radio style="margin: 4px 0px" :value="6">外国护照</a-radio>
              <a-radio style="margin: 4px 0px" :value="15">台胞证</a-radio>
              <a-radio style="margin: 4px 0px" :value="16"
                >港澳台居民身份证</a-radio
              >
              <a-radio style="margin: 4px 0px" :value="99">其它</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="出租方证件号码" prop="personCertNumber">
            <a-input
              v-model="form.personCertNumber"
              placeholder="请输入出租方证件号码"
              :disabled="form.hasEntrustRent == 0"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.lessorType == 1">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租方证件类别" prop="certType">
            <a-radio-group
              v-model="form.certType"
              :disabled="form.hasEntrustRent == 0"
            >
              <a-radio :value="19">统一社会信用代码</a-radio>
              <a-radio :value="99">其他</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="出租方证件号码" prop="certNumber">
            <a-input
              v-model="form.certNumber"
              placeholder="请输入出租方证件号码"
              :disabled="form.hasEntrustRent == 0"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.lessorType == 1">
      <a-row :gutter="24">
        <a-col :span="24">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item label="出租方法定代表人" prop="legalPerson">
                <a-input
                  v-model="form.legalPerson"
                  placeholder="请输入出租方法定代表人"
                  :disabled="form.hasEntrustRent == 0"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="地区" prop="country">
            <a-form-model-item
              prop="country"
              :style="{
                display: 'inline-block',
                width: 'calc(50% - 12px)',
              }"
            >
              <a-select
                placeholder="请选择国家"
                v-model="form.country"
                :not-found-content="fetching.country ? undefined : null"
                @dropdownVisibleChange="countryDictionaries"
              >
                <a-spin
                  v-if="fetching.country"
                  slot="notFoundContent"
                  size="small"
                />
                <a-select-option
                  v-else
                  v-for="country in dictionaries.country"
                  :key="country.value"
                >
                  {{ country.note }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              v-if="form.country == 156"
              prop="provinceCityRegion"
              :style="{
                display: 'inline-block',
                width: 'calc(50% - 12px)',
              }"
            >
              <a-cascader
                v-model="form.provinceCityRegion"
                :options="options.addressCode"
                :load-data="loadData"
                placeholder="请选择省/市/区（县）"
                notFoundContent="正在加载..."
                change-on-select
                @popupVisibleChange="areaDictionaries"
                @change="onHousingResAddressChange"
              >
                <template slot="displayRender" slot-scope="{ labels }">
                  {{
                    (!selectProvinceType ||
                      !(options?.addressCode?.length > 0)) &&
                    form?.provinceCityRegion?.length > 0
                      ? "上海 / 虹口区 / 曲阳路接到"
                      : labels.join(" / ")
                  }}
                </template>
              </a-cascader>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="注册地(地址)" prop="registAddress">
            <a-input
              v-model="form.registAddress"
              placeholder="输入注册地（地址）"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.lessorType == 1">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租方是否国资" prop="hasLessorStateOwned">
            <a-radio-group
              v-model="form.hasLessorStateOwned"
              :disabled="form.hasEntrustRent == 0"
            >
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="出租方经济类型" prop="economicTypeLessor">
            <a-select
              v-model="form.economicTypeLessor"
              placeholder="请选择出租方经济类型"
              :disabled="form.hasEntrustRent == 0"
            >
              <a-select-option value="A05001"
                >国资监管机构/政府部门</a-select-option
              >
              <a-select-option value="A05002"
                >国有独资公司（企业）/国有全资企业</a-select-option
              >
              <a-select-option value="A05003">国有控股企业</a-select-option>
              <a-select-option value="A05004"
                >国有事业单位，国有社团等</a-select-option
              >
              <a-select-option value="A05006">国有参股企业</a-select-option>
              <a-select-option value="A050070001">集体</a-select-option>
              <a-select-option value="A050070002">私营</a-select-option>
              <a-select-option value="A05008">外资企业</a-select-option>
              <a-select-option value="A05009">其他</a-select-option>
              <a-select-option value="A05010">国有实际控制企业</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col
      :span="24"
      v-if="form.lessorType == 1 && form.hasLessorStateOwned == 1"
    >
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="所属集团" prop="groupDepartmentName">
            <a-tree-select
              v-model="form.groupDepartmentName"
              show-search
              labelInValue
              :tree-data="affiliatedTreeData"
              :expandedKeys="treeExpandedKeys"
              :autoExpandParent="true"
              :filterTreeNode="false"
              @search="onAffiliatedTreeSearch"
              :searchValue="affiliatedTreeSearchValue"
              style="width: 100%"
              placeholder="请选择所属集团"
              searchPlaceholder="请输入需要查询的集团名称"
              :disabled="!isEditable || form.hasEntrustRent == 0"
              dropdownMatchSelectWidth
              :dropdown-style="{ maxHeight: '600px', overflow: 'auto' }"
              @focus="handleAffiliatedTreeVisible"
            >
              <a-spin
                v-if="affiliatedTreeLoading"
                slot="notFoundContent"
                size="small"
              />
            </a-tree-select>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="监管部门" prop="regulatoryAuthorities">
            <a-tree-select
              v-model="form.regulatoryAuthorities"
              show-search
              labelInValue
              :tree-data="regulatoryTreeData"
              :expandedKeys="treeExpandedKeys"
              :autoExpandParent="true"
              :filterTreeNode="false"
              @search="onRegulatoryTreeSearch"
              :searchValue="regulatoryTreeSearchValue"
              style="width: 100%"
              placeholder="请选择监管部门"
              searchPlaceholder="请输入需要查询的监管部门"
              :disabled="!isEditable || form.hasEntrustRent == 0"
              dropdownMatchSelectWidth
              :dropdown-style="{ maxHeight: '600px', overflow: 'auto' }"
              @focus="handleRegulatoryTreeVisible"
            >
              <a-spin
                v-if="regulatoryTreeLoading"
                slot="notFoundContent"
                size="small"
              />
            </a-tree-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24" v-if="form.lessorType == 2">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="电子邮件" prop="email">
            <a-input v-model="form.email" placeholder="请输入电子邮件" />
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="通讯地址" prop="mailingAddress">
            <a-input
              v-model="form.mailingAddress"
              placeholder="请输入通讯地址"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
const LEAF_REGIONS = ["台湾省", "香港特别行政区", "澳门特别行政区"];
import {
  getProvinceList,
  getAreaList,
  getCountry,
} from "@/api/shexgrp/Dictionaries.js";
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      //省市区地址
      options: {
        addressCode: [],
      },
      //是否选中一级地址标志位，用于判断是否显示固定地址
      selectProvinceType: false,
      //缓冲标志位
      fetching: {
        country: false,
      },
      //字典
      dictionaries: {
        country: [
          {
            value: "156",
            note: "中国",
            classify: "",
          },
        ],
      },
      //所属集团/监管部门
      affiliatedOriginTreeData: [],
      regulatoryOriginTreeData: [],
      affiliatedTreeLoading: false,
      regulatoryTreeLoading: false,
      affiliatedTreeData: [],
      regulatoryTreeData: [],
      affiliatedTreeSearchValue: "",
      regulatoryTreeSearchValue: "",
      treeExpandedKeys: [],
    };
  },
  methods: {
    //国家字典
    countryDictionaries(visible) {
      if (!visible) return;
      // 已有数据则不再请求
      if (this.dictionaries.country.length > 0) return;
      //获取字典内容
      this.fetching.country = true;
      getCountry()
        .then((res) => {
          if (res && res.code === "200") {
            this.dictionaries.country = res.data || [];
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          this.fetching.country = false;
        });
    },

    // 用户“选中一级地址”时触发
    onHousingResAddressChange() {
      this.selectProvinceType = true;
    },

    //获取省份列表
    async areaDictionaries(visible) {
      if (!visible) return;

      // ✅ 已经有省份数据，直接返回（防止重复请求）
      if (this.options.addressCode.length > 0) return;

      try {
        const res = await getProvinceList();
        if (res?.code === "200") {
          setTimeout(() => {
            this.options.addressCode = (res.data || []).map((item) => ({
              label: item.XZQYMC,
              value: item.XZQYDM,
              isLeaf: LEAF_REGIONS.includes(item.XZQYMC),
            }));
            this.options.addressCode = this.sortAreaList(
              this.options.addressCode
            );
          }, 300);
        }
      } catch (e) {
        console.error("省份列表加载失败", e);
      }
    },

    //便利性优化排序地点
    sortAreaList(list) {
      const CURRENCY_PRIORITY = {
        北京: 1,
        上海: 2,
      };

      return list.slice().sort((a, b) => {
        const pa = CURRENCY_PRIORITY[a.label] || 999;
        const pb = CURRENCY_PRIORITY[b.label] || 999;
        return pa - pb;
      });
    },

    //更新新地区列表信息
    async loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];

      // 开启当前节点 loading（自动显示 Spin）
      targetOption.loading = true;

      try {
        const res = await getAreaList({
          sjxzqydm: targetOption.value,
        });

        if (res?.code === "200") {
          targetOption.children = (res.data || []).map((item) => ({
            label: item.XZQYMC,
            value: item.XZQYDM,
            isLeaf: selectedOptions.length >= 2, // 后端返回是否还有下级
          }));
          this.options.addressCode = [...this.options.addressCode];
        }
      } catch (e) {
        console.error("级联地址加载失败", e);
      } finally {
        // 关闭 loading
        targetOption.loading = false;
      }
    },

    //点击所属集团树搜索下拉框
    async handleAffiliatedTreeVisible() {
      // 已加载过，直接用
      if (this.affiliatedOriginTreeData.length > 0) {
        this.affiliatedTreeSearchValue = "";
        // 重置树展示
        this.affiliatedTreeData = this.affiliatedOriginTreeData;
        return;
      }
      //首次加载，调用后端接口获取联交所 所属企业字典
      this.affiliatedTreeLoading = true;
      try {
        const res = await getOrgTree();
        if (res.code !== "200") return;
        //将后端树结构映射成ant-vue的书接口
        const tree = this.mapToAffiliatedTreeSelect(res.data);

        this.affiliatedOriginTreeData = tree;
        this.affiliatedTreeData = tree;
      } catch (e) {
        console.error("所属集团树加载失败", e);
      } finally {
        this.affiliatedTreeLoading = false;
      }
    },
    /**
     * 后端树数据 → TreeSelect 树数据
     * CODE → value / key
     * NAME → title
     */
    mapToAffiliatedTreeSelect(data = [], parentKey = "") {
      return data.map((item, index) => {
        const currentKey = item.ID;

        const children = Array.isArray(item.children)
          ? this.mapToAffiliatedTreeSelect(item.children, currentKey)
          : [];

        // ⭐ 核心业务规则
        const canSelect = String(item.FILL_TYPE_CODE) === "2";

        return {
          title: item.NAME || item.CODE,
          key: currentKey,
          value: currentKey, // 只用于 TreeSelect 唯一标识
          // 是否可选，完全由业务字段决定
          selectable: canSelect,
          disabled: !canSelect,
          children,
        };
      });
    },
    //搜索树结构内容
    onAffiliatedTreeSearch(value) {
      this.affiliatedTreeSearchValue = value;

      if (!value) {
        // 清空搜索 → 恢复完整树
        this.affiliatedTreeData = this.affiliatedOriginTreeData;
        this.treeExpandedKeys = ["ROOT"];
        return;
      }

      const expandedKeys = [];
      const filteredTree = this.filterTreeByKeyword(
        this.affiliatedOriginTreeData,
        value,
        expandedKeys
      );

      this.affiliatedTreeData = filteredTree;
      this.treeExpandedKeys = expandedKeys;
    },

    //点击监管部门树搜索下拉框
    async handleRegulatoryTreeVisible() {
      // 已加载过，直接用
      if (this.regulatoryOriginTreeData.length > 0) {
        this.regulatoryTreeSearchValue = "";
        // 重置树展示
        this.regulatoryTreeData = this.regulatoryOriginTreeData;
        return;
      }
      //首次加载，调用后端接口获取联交所 所属企业字典
      this.regulatoryTreeLoading = true;
      try {
        const res = await getOrgList();
        if (res.code !== "200") return;
        //将后端树结构映射成ant-vue的书接口
        const tree = this.mapToRegulatoryListSelect(res.data);
        this.regulatoryOriginTreeData = tree;
        this.regulatoryTreeData = tree;
      } catch (e) {
        console.error("监管部门加载失败", e);
      } finally {
        this.regulatoryTreeLoading = false;
      }
    },
    /**
     * 后端树数据 → TreeSelect 树数据
     * CODE → value / key
     * NAME → title
     */
    mapToRegulatoryListSelect(data = []) {
      const seenCode = new Set();

      return (
        data
          // ① 业务过滤：只保留可选组织
          .filter((item) => String(item.FILL_TYPE_CODE) !== "1")
          // ② CODE 去重：只保留第一次出现的
          .filter((item) => {
            if (seenCode.has(item.CODE)) return false;
            seenCode.add(item.CODE);
            return true;
          })
          // ③ 标准化映射
          .map((item) => ({
            key: item.ID,
            title: item.NAME,
            value: item.CODE,
          }))
      );
    },

    // 搜索监管部门（兼容 list / tree）
    onRegulatoryTreeSearch(value) {
      this.regulatoryTreeSearchValue = value;

      if (!value) {
        this.regulatoryTreeData = this.regulatoryOriginTreeData;
        this.regulatoryTreeExpandedKeys = [];
        return;
      }

      const expandedKeys = [];

      const filtered = this.filterTreeByKeyword(
        this.regulatoryOriginTreeData,
        value,
        expandedKeys
      );

      this.regulatoryTreeData = filtered;
      this.regulatoryTreeExpandedKeys = expandedKeys;
    },

    /**
     * 通用 Tree / List 模糊搜索
     * - 支持 tree / list
     * - 忽略大小写
     * - 自动维护 expandedKeys
     */
    filterTreeByKeyword(tree = [], keyword, expandedKeys = []) {
      const result = [];
      const searchText = (keyword || "").toLowerCase().trim();

      tree.forEach((node) => {
        const title = (node.title || "").toLowerCase();
        const titleMatch =
          title.includes(searchText) || this.fuzzyMatch(title, searchText);

        const hasChildren =
          Array.isArray(node.children) && node.children.length > 0;

        // ===== list 模式 =====
        if (!hasChildren) {
          if (titleMatch) {
            result.push({ ...node });
          }
          return;
        }

        // ===== tree 模式 =====
        const filteredChildren = this.filterTreeByKeyword(
          node.children,
          searchText,
          expandedKeys
        );

        if (titleMatch || filteredChildren.length > 0) {
          result.push({
            ...node,
            children: filteredChildren,
          });

          if (filteredChildren.length > 0) {
            expandedKeys.push(node.key);
          }
        }
      });

      return result;
    },

    //模糊查询组件
    fuzzyMatch(text, keyword) {
      let t = 0;
      for (let k = 0; k < keyword.length; k++) {
        t = text.indexOf(keyword[k], t);
        if (t === -1) return false;
        t++;
      }
      return true;
    },
  },
};
</script>

<style>
</style>